Nebula = function(scene,camera) {
	/*---------------------------------------------------
		VARIABLES
	--------------------------------------------------*/
	this.scene = scene;
	this.camera = camera;
	this.universeSize = 550;
	this.counter = 0;
	this.init();
};

Nebula.prototype = {
    
	constructor: Nebula,
    
    /*---------------------------------------------------
		INITIALIZER
	--------------------------------------------------*/
	
	init : function(){
		this.clock = new THREE.Clock();
		this.setTextures();
		this.addSphereUniverse();
		this.addLensFlare();
		this.addNebulaes();
		//this.addSun();
		//this.addPlanets();
		this.hideLensFlare();
	},
	
	setTextures : function(){

		this.background = this.getTexture( "nebulaBK" );

		this.backgroundStars = this.getTexture( "starsBK" );

		this.nebulaeTexture1 = this.getTexture( "nebulaeTexture1" );
		this.nebulaeTexture2 = this.getTexture( "nebulaeTexture2" );
		this.nebulaeTexture3 = this.getTexture( "nebulaeTexture3" );
		this.nebulaeTexture4 = this.getTexture( "nebulaeTexture4" );
		this.avalonTexture  = this.getTexture( "avalonTexture" );
		this.textureFlare0 = this.getTexture( "textureFlare0" );

		this.textureFlare2 = this.getTexture( "textureFlare2" );

		this.textureFlare3 = this.getTexture( "textureFlare3" );


	},
	
	getTexture : function(id){
		var texture = new THREE.Texture(app.loader.getItem(id));
		texture.needsUpdate = true;
		return texture;
	},

	addSphereUniverse : function(){
		
		this.background.magFilter = THREE.NearestFilter;
		this.background.minFilter = THREE.NearestMipMapNearestFilter;

		this.backgroundStars.magFilter = THREE.NearestFilter;
		this.backgroundStars.minFilter = THREE.NearestMipMapNearestFilter;

		var sphere = new THREE.SphereBufferGeometry(  this.universeSize , 16, 16);
		var material = new THREE.MeshBasicMaterial( {color: 0xffffff, map:this.background} );
		material.side = 1;
		material.opacity = 0.425;
		material.transparent = true;
		this.sphereMesh = new THREE.Mesh( sphere, material );
		this.scene.add(this.sphereMesh);

		var sphereStars = new THREE.SphereBufferGeometry(  this.universeSize + 3, 16, 16);
		var materialStars = new THREE.MeshBasicMaterial( {color: 0xffffff, map:this.backgroundStars} );
		materialStars.side = 1;
		
		this.starMesh = new THREE.Mesh( sphereStars, materialStars );
		this.scene.add(this.starMesh);
	
	},

	addLensFlare : function(){
		this.fakeFlare = [];
		this.flareGroup = new THREE.Group();
		this.sun = this.addFlatSprite(100, 100,this.textureFlare0,1, 20, 30, -80,true,false);
		this.sun.distance = 0;
		
		
		this.flare1 = this.addFlatSprite(0.5, 0.5,this.textureFlare3,1, 20, 30, -2,true,false);
		this.flare1.distance = 2;

		this.flare2 = this.addFlatSprite(0.8, 0.8,this.textureFlare3,1, 20, 30, -2,true,false);
		this.flare2.distance = 1.5;

		this.flare3 = this.addFlatSprite(0.6, 0.6,this.textureFlare3,1, 20, 30, -2,true,false);
		this.flare3.distance = 1.8;

		this.flare4 = this.addFlatSprite(0.3, 0.3,this.textureFlare3,1, 20, 30, -2,true,false);
		this.flare4.distance = 1;

		this.scene.remove(this.flare1);
		this.scene.remove(this.flare2);
		this.scene.remove(this.flare3);
		this.scene.remove(this.flare4);
		

		this.flareGroup.add(this.sun);
		this.flareGroup.add(this.flare1);
		this.flareGroup.add(this.flare2);
		this.flareGroup.add(this.flare3);
		this.flareGroup.add(this.flare4);
		
		this.fakeFlare.push(this.sun);
		this.fakeFlare.push(this.flare1);
		this.fakeFlare.push(this.flare2);
		this.fakeFlare.push(this.flare3);
		this.fakeFlare.push(this.flare4);
		this.scene.add(this.flareGroup);
	},

	getCoordinates:function( element, camera ) {
		var tempPosition = new THREE.Vector3();
		tempPosition.set( this.sun.matrixWorld.elements[ 12 ], this.sun.matrixWorld.elements[ 13 ], this.sun.matrixWorld.elements[ 14 ] );

		tempPosition.applyMatrix4( camera.matrixWorldInverse );
		tempPosition.applyProjection( camera.projectionMatrix );
		return tempPosition;
	},

	showLensFlare : function(){
		this.scene.add( this.lensFlare );
	},
	
	hideLensFlare : function(){
		//this.lensFlare.visible = false;
		//this.scene.remove( this.lensFlare );
	},

	lensFlareUpdateCallback : function(  ) {

		var positionScreen = this.getCoordinates(this.flareGroup,this.camera);
		if( (positionScreen.x > 2 ) || ( positionScreen.x < -2 ) ||(positionScreen.y > 2.5) ){
			this.flareGroup.visible = false;
		}else{
			this.flareGroup.visible = true;
		}
		var f, fl = this.fakeFlare.length;
		var flare;
		var vecX = - positionScreen.x * 2;
		var vecY = - positionScreen.y * 2;
		
		//console.log(vecX)
		for ( f = 0; f < fl; f ++ ) {

			flare = this.fakeFlare[ f ];
			flare.position.x = positionScreen.x + vecX * flare.distance;
			flare.position.y = positionScreen.y + vecY * flare.distance;
			flare.wantedRotation = flare.position.x * Math.PI * 0.25;
			flare.rotation.z += ( flare.wantedRotation - flare.rotation.z  ) * 0.25;
			if(f === 0){
				flare.position.x += 30;
				flare.position.y += 30;
			}else{
				flare.position.x += 1.5;
				flare.position.y += 1.5;
			}
		}
	},

	addNebulaes : function(){
		this.nebulae1 = this.addFlatSprite(320, 160,this.nebulaeTexture1,0.8,120,-40,-200);
		this.nebulae2 = this.addFlatSprite(240, 240,this.nebulaeTexture2,1,-160,60,-100);
		this.nebulae2.rotation.y = 80 * Math.PI / 180;
		this.nebulae3 = this.addFlatSprite(160, 160,this.nebulaeTexture3,1,60,-10,100);
		this.nebulae3.rotation.y = 80 * Math.PI / 180;
		this.nebulae4 = this.addFlatSprite(300, 150,this.nebulaeTexture4,1,-60, 30,100);
		this.avalon = this.addFlatSprite(100, 40,this.avalonTexture,1,-60, 30,100);

	},

	addFlatSprite : function(w,h,sprite,opacity,x,y,z,add,depth){
		var geometry = new THREE.PlaneBufferGeometry( w, h, 1 );
		var flatMesh = new THREE.Mesh( geometry, this.getBasicMatAd( sprite, true, opacity, THREE.DoubleSide,add,depth ) );
		this.scene.add( flatMesh );
		flatMesh.lookAt(new THREE.Vector3( 0, 0, 0 ) );
		flatMesh.position.set( x, y, z );
		return flatMesh;
	},

	getBasicMatAd : function( sprite, transparent, opacity, side,add,depth ){
		var material = new THREE.MeshBasicMaterial( { color : 0xffffff, map : sprite } );
		material.transparent = transparent;
		material.side = side ;
		material.opacity = opacity;
		material.blending = (add === true) ? THREE.AdditiveBlending :  THREE.NormalBlending;
		material.depthWrite =   (depth !== undefined) ? depth : false;
		return material;
	},
	
	addSun : function(){
		var textureLoader = new THREE.TextureLoader();
				this.uniforms = {
					fogDensity: { value: 0.0 },
					fogColor:   { value: new THREE.Vector3( 0, 0, 0 ) },
					time:       { value: 1.0 },
					resolution: { value: new THREE.Vector2() },
					uvScale:    { value: new THREE.Vector2( 3.0, 1.0 ) },
					texture1 :   { value: textureLoader.load( "media/img/textures/sun/cloud.png?num=34" ) },
					texture2 :   { value: textureLoader.load( "media/img/textures/sun/lavatile.jpg" ) }
				};
				this.uniforms.texture1.value.wrapS = this.uniforms.texture1.value.wrapT = THREE.RepeatWrapping;
				this.uniforms.texture2.value.wrapS = this.uniforms.texture2.value.wrapT = THREE.RepeatWrapping;
				var size = 3;
				material = new THREE.ShaderMaterial( {
					uniforms: this.uniforms,
					vertexShader: document.getElementById( 'vertexShader2' ).textContent,
					fragmentShader: document.getElementById( 'fragmentShader2' ).textContent
				} );
				this.sunP = new THREE.Mesh( new THREE.SphereGeometry( size, 32, 32 ), material );
				this.sunP.rotation.x = 0.3;
				this.sunP.position.z = -1;
				this.sunP.position.y = -10;
				this.sunP.rotation.z = 90 * Math.PI / 180;
				this.scene.add( this.sunP );
	},

	addPlanets : function(){
		this.earth = THREEx.Planets.createEarth();
		this.scene.add(this.earth);
		this.earth.position.set( 0, -10, -5 );
		this.earth.scale.set( 7, 7, 7 );
		this.earth.rotation.z = 0.8;
		this.earthClouds = THREEx.Planets.createEarthCloud();
		this.scene.add(this.earthClouds);
		this.earthClouds.position.set( 0, -10, -5 );
		this.earthClouds.scale.set( 7.2, 7.2, 7.2 );
	},
	
	render : function(){
		if(app.scene) this.lensFlareUpdateCallback();
		//this.sunP.rotation.x  += 0.0005;
		//var delta = 5 * this.clock.getDelta();
		//this.uniforms.time.value += 0.2 * delta;
		//this.sunP.scale.set(1.5+0.6*Math.sin(this.sunP.rotation.x),1.5+0.6*Math.sin(this.sunP.rotation.x),1.5+0.6*Math.sin(this.sunP.rotation.x))
		//this.earth.rotation.y += 0.0005;
		//this.earthClouds.rotation.y += 0.0008;
	}

};
